export default __webpack_public_path__ + "static/media/bonehorde.5953653d.png";